import { render, staticRenderFns } from "./dataevento.vue?vue&type=template&id=91018e4c"
import script from "./dataevento.vue?vue&type=script&lang=js"
export * from "./dataevento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91018e4c')) {
      api.createRecord('91018e4c', component.options)
    } else {
      api.reload('91018e4c', component.options)
    }
    module.hot.accept("./dataevento.vue?vue&type=template&id=91018e4c", function () {
      api.rerender('91018e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/dataevento.vue"
export default component.exports